import {
  CC_ONBOARDING_FIRST_STEP,
  CC_ONBOARDING_STATE_CHECKING_CREDIT,
  CC_ONBOARDING_STATE_CHECKING_ELIGIBILITY,
  CC_ONBOARDING_STATE_FAILED,
  CC_ONBOARDING_STATE_FINISHED,
  CC_ONBOARDING_STATE_NOT_STARTED,
  CC_ONBOARDING_STATE_OFFER_RECEIVED,
  CC_ONBOARDING_STATE_PREPARING_CARD,
  CC_ONBOARDING_STEP_ADDRESS,
  CC_ONBOARDING_STEP_OFFER,
  CC_ONBOARDING_STEP_DECLINED,
  CC_ONBOARDING_STEP_PENDING,
  CC_ONBOARDING_STEP_PHONE,
  CC_ONBOARDING_STEP_REVIEW,
  CC_ONBOARDING_STEP_SSN,
  CC_ONBOARDING_STEP_SUBMIT,
  CC_ONBOARDING_STEP_SUCCESS,
  CC_ONBOARDING_STEP_DENIED,
} from 'components/features/creditCard/creditCardStore/constants'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { useMemo } from 'react'

const dataCollectingSteps: Set<string> = new Set([
  CC_ONBOARDING_STEP_ADDRESS,
  CC_ONBOARDING_STEP_PHONE,
  CC_ONBOARDING_STEP_SSN,
  CC_ONBOARDING_STEP_REVIEW,
])

export const usePickStep = (onboarding: CreditCardDataState['onboarding'], currentStep: string) => {
  return useMemo(() => {
    if (!onboarding) {
      return null
    }

    switch (onboarding.state) {
      case CC_ONBOARDING_STATE_NOT_STARTED: {
        if (onboarding.step === CC_ONBOARDING_STEP_OFFER) {
          // This would happen if a user got an offer but declined or was denied.
          return CC_ONBOARDING_STEP_REVIEW
        }

        const isDataCollectingStep = dataCollectingSteps.has(currentStep)
        if (!isDataCollectingStep) {
          return CC_ONBOARDING_STEP_REVIEW
        }

        if (onboarding.step === CC_ONBOARDING_STEP_REVIEW && currentStep) {
          return currentStep
        }

        return onboarding.step || CC_ONBOARDING_FIRST_STEP
      }

      case CC_ONBOARDING_STATE_CHECKING_ELIGIBILITY: {
        return CC_ONBOARDING_STEP_PENDING
      }

      case CC_ONBOARDING_STATE_OFFER_RECEIVED: {
        if (onboarding.step === CC_ONBOARDING_STEP_DECLINED) {
          return CC_ONBOARDING_STEP_DECLINED
        }

        return CC_ONBOARDING_STEP_OFFER
      }

      case CC_ONBOARDING_STATE_CHECKING_CREDIT:
      case CC_ONBOARDING_STATE_PREPARING_CARD: {
        return CC_ONBOARDING_STEP_SUBMIT
      }

      case CC_ONBOARDING_STATE_FINISHED: {
        return CC_ONBOARDING_STEP_SUCCESS
      }

      case CC_ONBOARDING_STATE_FAILED: {
        return CC_ONBOARDING_STEP_DENIED
      }
    }

  }, [onboarding, currentStep])
}
